<template>
  <div class="winners-2019-place-winners-card-subtitle"><slot /></div>
</template>

<script>
export default {
  name: "Winners2019PlaceWinnersCardSubtitle"
};
</script>

<style lang="scss">
.winners-2019-place-winners-card-subtitle {
  text-align: center;
  line-height: 40px;
  height: 40px;
  background: rgba(#000a25, 0.7);
  border-radius: 4px;
  width: 100%;
  font-weight: 700;
  margin-bottom: 20px;
}
</style>
